import React from 'react';
import { Result as AntdResult, Button } from 'antd';
import { useTranslation } from 'react-i18next';

export function Result({ onSubmitAgain }) {
  const { t } = useTranslation();

  return (
    <AntdResult
      status="success"
      title={t('status.success-submit')}
      extra={[
        <Button key="buy" type="primary" onClick={onSubmitAgain}>
          {t('button.submit-new')}
        </Button>,
      ]}
    />
  );
}
